import React from 'react'

export const DateArrow = () => (
  <svg width='22' height='16' viewBox='0 0 22 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path d='M1 8L21 8' stroke='#DDA41D' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
    <path d='M14 1L21 8L14 15' stroke='#DDA41D' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
  </svg>
)
